import { FC, useContext, useEffect } from 'react';

import InlineMessage from '@ingka/inline-message';
import errorMessageIcon from '@ingka/ssr-icon/paths/incorrect';
import { t } from '@onlinepayments/payments-library';
import { Redirect, RouteComponentProps } from 'react-router-dom';

import { Card } from '../../components/toolkit';
import { LoadingState } from '../../enums/LoadingState';
import { Path } from '../../enums/Path';
import { PayorderBackendErrorMessage } from '../../enums/PayorderBackendErrorMessage';
import { OrderDetailsContextProvider } from '../../OrderDetailsContext';
import { PayorderContext } from '../../PayorderContext';

import OrderContainer from './OrderContainer';
import PaymentContainer from './PaymentContainer';

import './ReviewAndPayContainer.scss';

const ReviewAndPayContainer: FC<RouteComponentProps> = ({ history }) => {
  const {
    contextState: {
      paymentContext: {
        contextId: paymentContextId,
        loadingState: paymentContextLoadingState,
        error: paymentContextError,
      },
      orderDetails,
      payorderContext: { loadingState: payorderContextLoadingState },
      queryParams,
    },
  } = useContext(PayorderContext);

  const variantParam = queryParams.variant ? queryParams.variant.toLowerCase() : '';
  const completePayment = () => history.push(Path.ProcessingPayment);

  useEffect(() => {
    if (variantParam === 'b2b-redirect') {
      localStorage.setItem('b2b-variant-order', orderDetails?.response?.orderNumber ?? '');
    }
  }, [orderDetails?.response?.orderNumber, variantParam]);

  if (orderDetails.loadingState === LoadingState.Failure) {
    return (
      <Redirect
        to={{
          pathname: Path.ValidateOrderFailure,
          state: { validationError: { status: 500 } },
        }}
      />
    );
  }

  if (payorderContextLoadingState === LoadingState.Failure) {
    return <Redirect to={Path.ValidateOrder} />;
  }

  function renderErrorMessage() {
    let message = t('generic_error_message');

    if (
      paymentContextError?.errorMessage?.includes(PayorderBackendErrorMessage.EmailAddressIsMissing)
    ) {
      message = t('order.email_address_missing_error');
    }

    return (
      <InlineMessage
        role="alert"
        variant="negative"
        ssrIcon={errorMessageIcon}
        className="my-150"
        body={message}
      />
    );
  }

  return (
    <OrderDetailsContextProvider order={orderDetails.response}>
      <Card
        className={`ReviewAndPayContainer ${
          ['boka', 'b2b-redirect'].includes(variantParam) ? 'boka-variant' : ''
        }`}
      >
        <h1 className="my-100 text-center">{t('review_and_pay_header')}</h1>

        {paymentContextLoadingState === LoadingState.Failure && renderErrorMessage()}

        <OrderContainer />

        {paymentContextId && orderDetails.response && (
          <PaymentContainer
            goToPaymentProcessingPage={completePayment}
            orderDetails={orderDetails.response}
          />
        )}
      </Card>
    </OrderDetailsContextProvider>
  );
};

export default ReviewAndPayContainer;
